import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\UserController::update
* @see app/Http/Controllers/User/UserController.php:60
* @route '/users/{user}'
*/
export const update = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '/users/{user}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\User\UserController::update
* @see app/Http/Controllers/User/UserController.php:60
* @route '/users/{user}'
*/
update.url = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: args.user,
    }

    return update.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\UserController::update
* @see app/Http/Controllers/User/UserController.php:60
* @route '/users/{user}'
*/
update.put = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\User\UserController::update
* @see app/Http/Controllers/User/UserController.php:60
* @route '/users/{user}'
*/
update.patch = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\User\UserController::updateProfileImage
* @see app/Http/Controllers/User/UserController.php:89
* @route '/users/{user}/profile-image'
*/
export const updateProfileImage = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: updateProfileImage.url(args, options),
    method: 'post',
})

updateProfileImage.definition = {
    methods: ["post"],
    url: '/users/{user}/profile-image',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\User\UserController::updateProfileImage
* @see app/Http/Controllers/User/UserController.php:89
* @route '/users/{user}/profile-image'
*/
updateProfileImage.url = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: args.user,
    }

    return updateProfileImage.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\UserController::updateProfileImage
* @see app/Http/Controllers/User/UserController.php:89
* @route '/users/{user}/profile-image'
*/
updateProfileImage.post = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: updateProfileImage.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\User\UserController::updatePassword
* @see app/Http/Controllers/User/UserController.php:119
* @route '/users/{user}/password'
*/
export const updatePassword = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updatePassword.url(args, options),
    method: 'put',
})

updatePassword.definition = {
    methods: ["put"],
    url: '/users/{user}/password',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\User\UserController::updatePassword
* @see app/Http/Controllers/User/UserController.php:119
* @route '/users/{user}/password'
*/
updatePassword.url = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: args.user,
    }

    return updatePassword.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\UserController::updatePassword
* @see app/Http/Controllers/User/UserController.php:119
* @route '/users/{user}/password'
*/
updatePassword.put = (args: { user: string | number } | [user: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updatePassword.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\User\UserController::showProfileImage
* @see app/Http/Controllers/User/UserController.php:25
* @route '/users/{userId}/profile-image/raw'
*/
export const showProfileImage = (args: { userId: string | number } | [userId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showProfileImage.url(args, options),
    method: 'get',
})

showProfileImage.definition = {
    methods: ["get","head"],
    url: '/users/{userId}/profile-image/raw',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\UserController::showProfileImage
* @see app/Http/Controllers/User/UserController.php:25
* @route '/users/{userId}/profile-image/raw'
*/
showProfileImage.url = (args: { userId: string | number } | [userId: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { userId: args }
    }

    if (Array.isArray(args)) {
        args = {
            userId: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        userId: args.userId,
    }

    return showProfileImage.definition.url
            .replace('{userId}', parsedArgs.userId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\UserController::showProfileImage
* @see app/Http/Controllers/User/UserController.php:25
* @route '/users/{userId}/profile-image/raw'
*/
showProfileImage.get = (args: { userId: string | number } | [userId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showProfileImage.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\UserController::showProfileImage
* @see app/Http/Controllers/User/UserController.php:25
* @route '/users/{userId}/profile-image/raw'
*/
showProfileImage.head = (args: { userId: string | number } | [userId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: showProfileImage.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\User\UserController::edit
* @see app/Http/Controllers/User/UserController.php:45
* @route '/profile'
*/
export const edit = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/profile',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\UserController::edit
* @see app/Http/Controllers/User/UserController.php:45
* @route '/profile'
*/
edit.url = (options?: RouteQueryOptions) => {
    return edit.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\UserController::edit
* @see app/Http/Controllers/User/UserController.php:45
* @route '/profile'
*/
edit.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\UserController::edit
* @see app/Http/Controllers/User/UserController.php:45
* @route '/profile'
*/
edit.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(options),
    method: 'head',
})

const UserController = { update, updateProfileImage, updatePassword, showProfileImage, edit }

export default UserController